@if (visible) {
<section class="mb-2 space-y-1.5">
  @if (attributedShare; as share) {
  <app-public-share-details
    [share]="share"
    [workType]="item.type"
    [shareUrl]="entry.page()?.social?.url"
  />
  } @if (entry.intent() === 'rating' && entry.rating() !== undefined) {
  <div class="rounded-xl bg-primary/10 p-4 space-y-2">
    <p>
      {{ "PUBLIC_WORK.CONFIRM_RATING" | translate: {rating: entry.rating()} }}
    </p>
    @if (item.userRating !== undefined && item.userRating !== null &&
    item.userRating !== entry.rating()) {
    <p class="text-sm">
      {{ "PUBLIC_WORK.EXISTING_RATING" | translate: {rating: item.userRating} }}
    </p>
    }
    <button
      type="button"
      [disabled]="saving"
      [attr.aria-busy]="saving"
      class="btn btn-small min-h-[44px] whitespace-nowrap"
      (click)="confirmRating()"
    >
      {{
        (saving ? "PUBLIC_WORK.SAVING" : "PUBLIC_WORK.SAVE_RATING") | translate
      }}
    </button>
    <button
      type="button"
      class="ml-3 text-sm underline whitespace-nowrap"
      [disabled]="saving"
      (click)="consume()"
    >
      {{ "DISCUSSION.CANCEL" | translate }}
    </button>
    @if (error) {
    <p role="alert">{{ "ERROR_UPDATE" | translate }}</p>
    }
  </div>
  } @if (entry.intent() === 'list') {
  <button
    type="button"
    class="btn btn-small min-h-[44px] whitespace-nowrap"
    (click)="openLists()"
  >
    {{ "PUBLIC_WORK.ADD_LIST" | translate }}
  </button>
  } @if (entry.intent() === 'echo') {
  <app-work-echo-button [item]="item" (click)="consume()" />
  @if (echo && !echo.shouldShowEchoButton) {
  <p class="text-sm" role="status">
    {{ "PUBLIC_WORK.ECHO_UNAVAILABLE" | translate }}
  </p>
  } }
</section>
}
